import * as React from "react";
import * as Tooltip from "@radix-ui/react-tooltip";
import { Info } from "lucide-react";

interface CustomTooltipProps {
  children: React.ReactNode;
}

const CustomTooltip = ({ children }: CustomTooltipProps) => {
  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center outline-none"
          >
            <Info size={16} />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="z-[9999] max-w-[230px] select-none rounded bg-purple-primary px-2 py-1 text-xs leading-none text-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]"
            side="top"
            sideOffset={2}
          >
            {children}
            <Tooltip.Arrow className="fill-purple-primary" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default React.memo(CustomTooltip);
